"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParagraphOneContent = void 0;
const lib_1 = require("@brandfree-front/lib");
const react_1 = __importDefault(require("react"));
const RootStore_1 = require("../../../stores/RootStore");
const ParagraphOneContent = (props) => {
    const { isMobile } = props;
    const { translate } = react_1.default.useContext(RootStore_1.RootStoreContext).translateStore;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("p", null,
            translate('gdpr.privacy.notification.paragraph.one.text1'),
            react_1.default.createElement(lib_1.Anchor, { url: "https://www.telia.ee/images/documents/tt/est/smart-wifi-privaatsusteade-est-rus-eng.pdf" }, translate('gdpr.privacy.notification.paragraph.one.smart.wifi.link')),
            translate('gdpr.privacy.notification.paragraph.one.text2'),
            "\u00A0",
            react_1.default.createElement(lib_1.Anchor, { url: "https://www.telia.ee/lepingud-ja-tingimused/" }, translate('gdpr.privacy.notification.paragraph.one.telias.homepage')),
            "."),
        react_1.default.createElement(lib_1.Heading, { level: isMobile ? 2 : 3, className: "h4 text-bold" }, translate('gdpr.privacy.notification.paragraph.one.text3')),
        react_1.default.createElement(lib_1.List, null,
            react_1.default.createElement(lib_1.ListItem, null,
                " ",
                translate('gdpr.privacy.notification.paragraph.one.text3.p1')),
            react_1.default.createElement(lib_1.ListItem, null,
                " ",
                translate('gdpr.privacy.notification.paragraph.one.text3.p2')),
            react_1.default.createElement(lib_1.ListItem, null,
                " ",
                translate('gdpr.privacy.notification.paragraph.one.text3.p3')),
            react_1.default.createElement(lib_1.ListItem, null,
                " ",
                translate('gdpr.privacy.notification.paragraph.one.text3.p4')),
            react_1.default.createElement(lib_1.ListItem, null,
                " ",
                translate('gdpr.privacy.notification.paragraph.one.text3.p5')),
            react_1.default.createElement(lib_1.ListItem, null,
                " ",
                translate('gdpr.privacy.notification.paragraph.one.text3.p6'))),
        react_1.default.createElement(lib_1.Heading, { level: isMobile ? 2 : 3, className: "h4 text-bold" }, translate('gdpr.privacy.notification.paragraph.one.heading2')),
        react_1.default.createElement("p", null, translate('gdpr.privacy.notification.paragraph.one.heading2.text'))));
};
exports.ParagraphOneContent = ParagraphOneContent;
